import { createElement, useState } from "react";
import { Trans } from "react-i18next";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { deleteHttp } from "@common/api/apiShared";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { DeletionResultWithBlockers } from "@common/components/deleteBlockedDialog/DeleteBlockedDialog.types";
import { IDeleteLegalEntityContactDialog } from "./DeleteLegalEntityContactDialog";

export function useDeleteLegalEntityContactHooks(props: IDeleteLegalEntityContactDialog) {
    const snackbar = useDotLegalSnackbar();
    const [blockedDeletion, setBlockedDeletion] = useState<DeletionResultWithBlockers | undefined>();

    const removeMutation = useDotLegalMutation(remove);

    const deleteContact = () => {
        removeMutation.mutateAsync(undefined, {
            onSuccess: (response: any) => {
                const result: DeletionResultWithBlockers = response.value();

                if (!result.isDeleted) {
                    setBlockedDeletion(result);
                    return;
                }

                props.onDeleted();
                snackbar.show(createElement(Trans, { i18nKey: "itemDeleted", values: { name: props.contactName } }));
            },
        });
    };

    async function remove() {
        return await deleteHttp<string>(`/LegalEntityContacts/${props.contactId}`);
    }

    return {
        deleteContact,
        inProgess: removeMutation.isLoading,
        blockedDeletion,
    };
}
